import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import classes from './attention-banner.module.sass'

const AttentionBanner = ({ content, variant }) => {
  const classNames = {
    [classes.attentionBanner]: true,
    [classes[variant]]: true,
  }

  return (
    <div className={cn(classNames)}>{content}</div>
  )
}

AttentionBanner.defaultProps = {
  content: '',
  variant: 'normal',
}

AttentionBanner.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.oneOf(['normal']),
}

export default AttentionBanner
